import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageContainer from "@/components/layouts/PageContainer";
import { Heading } from "@/components/heading";
import { Text } from "@/components/text";
import { Button } from "@/components/button";
import { ArrowLeftIcon } from "@heroicons/react/20/solid";
import { useCreateExamAssignment } from "@/apis/exam_assignments";
import ExamAssignmentForm from "./ExamAssignmentForm";

const ExamAssignmentCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const [serverError, setServerError] = useState<string | null>(null);

  // API 호출
  const { mutate: createExamAssignment, isPending } = useCreateExamAssignment();

  // 폼 제출 핸들러
  const handleSubmit = (formData: {
    title: string;
    exam_set: {
      exam_type: string;
      items: {
        exam_paper_id: string;
        order: number;
      }[];
    };
  }) => {
    createExamAssignment(formData as any, {
      onSuccess: () => {
        navigate("/exam_assignments");
      },
      onError: (error: any) => {
        setServerError(error?.message || "Failed to assign exam");
      },
    });
  };

  // 취소 핸들러
  const handleCancel = () => {
    navigate("/exam_assignments");
  };

  return (
    <PageContainer>
      <div className="space-y-6">
        <div className="flex items-center gap-4">
          <Button plain onClick={handleCancel}>
            <ArrowLeftIcon className="h-5 w-5" />
            Back
          </Button>

          <div>
            <Heading>Create Exam Assignment</Heading>
            <Text className="text-zinc-500">
              Create a new exam assignment with selected exam papers.
            </Text>
          </div>
        </div>

        {/* 서버 오류 표시 */}
        {serverError && (
          <div className="p-4 bg-red-50 text-red-600 rounded-md">
            {serverError}
          </div>
        )}

        {/* 할당 폼 */}
        <ExamAssignmentForm
          initialValues={{
            title: "",
            exam_set: {
              exam_type: "SAT",
              items: [],
            },
          }}
          isPending={isPending}
          onSubmit={handleSubmit}
          submitLabel="Create Assignment"
        />
      </div>
    </PageContainer>
  );
};

export default ExamAssignmentCreatePage;
